import StyledContainer from "style/styledContainer"
import styled, { css } from "styled-components"
import DrawerCom from "./DrawerCom"
import { Column, Row } from "style/preset"

import BaseBtnCom from "../BaseBtnCom"
import { CancelTextBtnWrap, DrawerWinOneTileWrap, DrawerWinTwoTileWrap, PaddingLeftRightWrap } from "./DrawerStyle"
import WarnBarCom from "components/WarnBarCom"
import { useCallback, useEffect, useRef, useState } from "react"
import { useAppDispatch, useAppSelector } from "hooks/redux/hooks"
import { setToAddress } from "hooks/redux/slices/coreInfoSlice"

interface Props {
    open: boolean
    closeChange?: (isOpen: boolean) => void
    onComplete?: (obj?: any) => void
}

const DrawerAddressCom = ({open, closeChange = (isOpen: boolean) => {}, onComplete = (obj) => {}}: Props) => {
    const { toToken, toChain, toAddress } = useAppSelector((state) => state.coreInfo)
    const dispatch = useAppDispatch()
    const inputRef = useRef<HTMLInputElement>(null);

    /**
     * 资源初始化
     */
    const fnInit = useCallback(() => {
        if(open) {
            // 初始化资源
            setAnotherAddress(toAddress)
            setTimeout(() => {
                inputRef.current?.focus()
            }, 300);
        } else {
            // 清理资源
            setAnotherAddress('')
        }
    }, [open, toAddress])

    useEffect(() => {
        fnInit()
    }, [fnInit])

    /**
     * 关闭回调
     */
    const [closeRandom, setCloseRandom] = useState(0)
    const fnClosed = (closed: boolean) => {
        closeChange(closed)
        setCloseRandom(0)
    }
    const fnCloseWin = useCallback(() => {
        setCloseRandom(closeRandom + 1)
    }, [closeRandom])

    /**
     * 完成回调
     */
    const fnConfirm = () => {
        dispatch(setToAddress(anotherAddress))
        fnCloseWin()
    }

    const [isError, setIsError] = useState(false)
    const [anotherAddress, setAnotherAddress] = useState('')
    const fnAddressChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = e.target.value
        setAnotherAddress(val)

        if(!(/^0[xX][0-9a-fA-F]{40}$/.test(val))) {
            setIsError(true);
        } else {
            setIsError(false);
        }
    }

    return open ? <DrawerCom isOpen={open} closeRandom={closeRandom} onClose={fnClosed}>
        <DrawerContentWrap $isError={isError}>
            <PaddingLeftRightWrap>
                <DrawerWinOneTileWrap>Send assets to an external address</DrawerWinOneTileWrap>
                <DrawerWinTwoTileWrap $mb="30px">Please input the wallet address where you'd like your ${toToken?.symbol} to be sent</DrawerWinTwoTileWrap>
                
                <AddressWrap>
                    <StyledContainer $mb="6px" $fontSize="12px" $lineHeight="14px" $roobertRegular>{toToken?.symbol} Address</StyledContainer>
                    <AddressInputWrap ref={inputRef} value={anotherAddress} placeholder="Type here" onChange={fnAddressChange}></AddressInputWrap>
                </AddressWrap>
                <StyledContainer $height="20px"></StyledContainer>

                <WarnBarCom isError={isError} desc={`Make sure this address is for $${toToken?.symbol} on ${toChain?.fullName}`}></WarnBarCom>
                <StyledContainer $height="100px"></StyledContainer>

                <BaseBtnCom disabled={(isError || !!!anotherAddress)} type={(isError || !!!anotherAddress) ? '2' : '3'} title={(isError || !!!anotherAddress) ? 'Please input the address' : 'Confirm address'} onClick={fnConfirm}></BaseBtnCom>

                <CancelTextBtnWrap onClick={() => setCloseRandom(closeRandom + 1)}>Cancel</CancelTextBtnWrap>
            </PaddingLeftRightWrap>
            
        </DrawerContentWrap>
    </DrawerCom> : <></>
}

const DrawerContentWrap = styled(StyledContainer)<{$isError: boolean}>`
    ${
        ({$isError, theme}) => $isError ? css`
            ${AddressWrap} {
                border-color: #E000E0;
            }
            ${AddressInputWrap} {
                color: #E000E0;
            }
        ` : css`
        `
    }
`

const AddressWrap = styled(Column)`
    padding: 12px 0 12px 15px;
    border-left: 1px dashed #B5B7BA;
`

const AddressInputWrap = styled.input`
    border: none;
    outline: none;
    font-size: 16px;
    line-height: 1;
    font-weight: 600;
    font-family: RoobertSemiBold;
    &::placeholder {
        color: #CACCCE;
    }
`

export default DrawerAddressCom